import React from 'react'
import GroupItem from './group-item'
import { getGroup } from '../../store/selectors'
import { withGroups } from '../../context/groups.context'
import { withStore } from '../../context/store.context'
import { changeGroupStatus } from '../../store/actions'

const GroupItemContainer = ({ id, groups, store }) => {
  const group = getGroup(groups, id)
  return (
    <GroupItem
      title={group.title}
      students={group.number_of_students}
      checked={store.selectedGroups[id] || false}
      onChange={e => store.dispatch(changeGroupStatus(id, e.target.checked))}
    />
  )
}

export default withStore(withGroups(GroupItemContainer))
